package com.zq.webproject.ui.purchaserecord

import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.setValue
import com.zq.webproject.model.PurchaseRecord
import com.zq.webproject.network.Repository
import com.zq.webproject.utils.TokenManager
import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.SupervisorJob
import kotlinx.coroutines.launch


/**
 * 购买记录页面ViewModel
 */
class PurchaseRecordViewModel {
    // 协程作用域
    private val viewModelScope = CoroutineScope(SupervisorJob() + Dispatchers.Main)

    // Repository 实例
    private val repository = Repository()

    // 购买记录列表
    var purchaseRecords by mutableStateOf<List<PurchaseRecord>>(emptyList())
        private set

    // 加载状态
    var isLoading by mutableStateOf(false)
        private set

    // 错误消息
    var errorMessage by mutableStateOf<String?>(null)
        private set

    /**
     * 加载购买记录
     */
    fun loadPurchaseRecords() {
        println("PurchaseRecordViewModel - 开始加载购买记录") // 日志输出

        viewModelScope.launch {
            isLoading = true
            errorMessage = null

            try {
                val token = TokenManager.getToken()
                println("PurchaseRecordViewModel - 当前Token: $token") // 日志输出

                if (token.isNullOrEmpty()) {
                    println("PurchaseRecordViewModel - Token为空，无法加载购买记录") // 日志输出
                    errorMessage = "未登录，请先登录"
                    isLoading = false
                    return@launch
                }

                println("PurchaseRecordViewModel - 开始请求购买记录接口") // 日志输出

                val response = repository.getUserPurchaseHistory()

                // 打印完整响应数据
                println("PurchaseRecordViewModel - 接口响应成功") // 日志输出
                println("PurchaseRecordViewModel - 响应码: ${response.code}") // 日志输出
                println("PurchaseRecordViewModel - 响应消息: ${response.message}") // 日志输出
                println("PurchaseRecordViewModel - 记录数量: ${response.data.size}") // 日志输出

                if (response.code == 200) {
                    purchaseRecords = response.data
                    println("PurchaseRecordViewModel - 购买记录加载成功，共 ${response.data.size} 条") // 日志输出

                    // 打印每条记录的详细信息
                    response.data.forEachIndexed { index, record ->
                        println("PurchaseRecordViewModel - 记录[$index]: 订单号=${record.orderNo}, 商品=${record.productName}, 价格=${record.productPrice}, 支付状态=${record.getPayStatusText()}, 网盘链接=${record.productImage3}") // 日志输出
                    }
                } else {
                    errorMessage = response.message
                    println("PurchaseRecordViewModel - 加载失败: ${response.message}") // 日志输出
                }
            } catch (e: Exception) {
                errorMessage = "加载失败: ${e.message}"
                println("PurchaseRecordViewModel - 加载异常: ${e.message}") // 日志输出
                e.printStackTrace()
            } finally {
                isLoading = false
                println("PurchaseRecordViewModel - 加载完成，isLoading=false") // 日志输出
            }
        }
    }
}